import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The QueryClientProvider that used to wrap this was removed along with
// @tanstack/react-query: it was configured and mounted, but the app has zero
// useQuery/useMutation calls — every fetch goes through `api` directly. It was
// shipping ~40 kB to do nothing. Reinstate it with the first real useQuery.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
